import { TextureAtlasUtils } from "../TextuAtlasUtils";



export const enum eProgressBarDir {
    horizontalR,
    horizontalL,
    verticalU,
    verticalD,
}



export class ProgressBar {
    /**
     * (RO) Entita s progress barem
     */
    get entity(): pc.Entity { return this._entity; }
    private _entity: pc.Entity;

    /**
     * Stav progress baru v rozsahu 0 az 1
     */
    get state(): number { return this._state; }
    set state(state: number) {
        if (this._state != state) {
            this._state = state;
            this.updateFilling();
        }
    }
    private _state: number;

    private _fillingFrameRc: pc.Vec4;
    private _fillingEl: pc.ElementComponent;

    private _texture: pc.Texture;
    private _dir: eProgressBarDir;

    private _tmpRc: pc.Vec4 = new pc.Vec4();

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(atlas: pc.TextureAtlas, barFrameKey: string, fillingFrameKey: string, fillingX: number = 0, fillingY: number = 0, dir: eProgressBarDir = eProgressBarDir.horizontalR) {
        this._texture = atlas.texture;
        this._dir = dir;

        // Pozadi
        let bar = new pc.Entity("progressBar");
        let barFrameRc = (<pc.TextureAtlasFrame>atlas.frames[barFrameKey]).rect;

        this._entity = bar;

        bar.addComponent(pc.eCompomentType.element, {
            type: pc.ELEMENTTYPE_IMAGE,
            texture: atlas.texture,
            width: barFrameRc.z,
            height: barFrameRc.w,
            anchor: [0, 1, 0, 1],
            pivot: [0, 1]
        });

        TextureAtlasUtils.getTexFrameRegion(this._texture, barFrameRc, this._tmpRc);
        bar.element.rect = this._tmpRc;

        // Vypln
        let filling = new pc.Entity();
        let fillingFrameRc = (<pc.TextureAtlasFrame>atlas.frames[fillingFrameKey]).rect;

        this._fillingFrameRc = fillingFrameRc;

        this._fillingEl = filling.addComponent(pc.eCompomentType.element, {
            type: pc.ELEMENTTYPE_IMAGE,
            texture: atlas.texture,
            width: this._fillingFrameRc.z,
            height: this._fillingFrameRc.w,
        }) as pc.ElementComponent;

        TextureAtlasUtils.getTexFrameRegion(this._texture, fillingFrameRc, this._tmpRc);
        this._fillingEl.rect = this._tmpRc;
        this._fillingEl.anchor.set(0, 0, 0, 0);
        filling.setLocalPosition(fillingX, fillingY, 0);

        if (dir == eProgressBarDir.horizontalL) {
            this._fillingEl.pivot.set(1, 0);
        }
        else if (dir == eProgressBarDir.verticalD) {
            this._fillingEl.pivot.set(0, 1);
        }

        bar.addChild(filling);

        // Stav
        this._state = 0;
        this.updateFilling();
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private updateFilling(): void {
        if (this._dir == eProgressBarDir.horizontalL || this._dir == eProgressBarDir.horizontalR) {
            let w = Math.round(this._state * this._fillingFrameRc.z);

            if (this._dir == eProgressBarDir.horizontalL)
                this._fillingEl.rect.x = (this._fillingFrameRc.x + this._fillingFrameRc.z - w) / this._texture.width;

            this._fillingEl.rect.z = w / this._texture.width;
            this._fillingEl.width = w;
        }
        else {
            let h = Math.round(this._state * this._fillingFrameRc.w);

            if (this._dir == eProgressBarDir.verticalD)
                this._fillingEl.rect.y = (this._fillingFrameRc.y + this._fillingFrameRc.w - h) / this._texture.height;

            this._fillingEl.rect.w = h / this._texture.height;
            this._fillingEl.height = h;
        }

        this._fillingEl.rect = this._fillingEl.rect;
    }
}